import React, { useEffect, useRef } from 'react';
import { FaSalesforce, FaHubspot, FaSlack, FaGoogle, FaMicrosoft, FaShopify, FaAws, FaRegComment } from 'react-icons/fa';
import { SiZapier, SiSegment, SiStripe, SiNotion } from 'react-icons/si';
import { BiLogoZoom, BiLogoLinkedin } from 'react-icons/bi';
import {
  FaJs, FaPython, FaJava, FaReact, FaAngular, FaVuejs,
  FaNodeJs
} from "react-icons/fa";

import {
  SiTypescript, SiNextdotjs, SiExpress, SiDjango,
  SiSpringboot, SiMongodb, SiMysql, SiPostgresql,
  SiDocker, SiKubernetes, SiCplusplus
} from "react-icons/si";

import {
  SiRedux, SiTailwindcss, SiBootstrap, SiNestjs, SiGraphql,
  SiFirebase, SiRedis, SiSqlite, SiFlutter, SiKotlin, SiSwift,
  SiVercel, SiNetlify, SiGithub, SiGitlab, SiBitbucket,
  SiJenkins, SiNginx, SiPostman, SiWebpack
} from "react-icons/si";
const integrations = [
  { icon: <FaJs className="text-3xl text-yellow-400" />, name: "JavaScript", category: "Language" },
  { icon: <FaPython className="text-3xl text-blue-400" />, name: "Python", category: "Language" },
  { icon: <SiTypescript className="text-3xl text-blue-500" />, name: "TypeScript", category: "Language" },
  { icon: <FaJava className="text-3xl text-red-500" />, name: "Java", category: "Language" },
  { icon: <SiCplusplus className="text-3xl text-blue-400" />, name: "C++", category: "Language" },

  { icon: <FaReact className="text-3xl text-cyan-400" />, name: "React", category: "Frontend" },
  { icon: <SiNextdotjs className="text-3xl text-white" />, name: "Next.js", category: "Frontend" },
  { icon: <FaAngular className="text-3xl text-red-500" />, name: "Angular", category: "Frontend" },
  { icon: <FaVuejs className="text-3xl text-green-400" />, name: "Vue.js", category: "Frontend" },

  { icon: <FaNodeJs className="text-3xl text-green-500" />, name: "Node.js", category: "Backend" },
  { icon: <SiExpress className="text-3xl text-gray-300" />, name: "Express.js", category: "Backend" },
  { icon: <SiDjango className="text-3xl text-green-400" />, name: "Django", category: "Backend" },
  { icon: <SiSpringboot className="text-3xl text-green-500" />, name: "Spring Boot", category: "Backend" },

  { icon: <SiMongodb className="text-3xl text-green-500" />, name: "MongoDB", category: "Database" },
  { icon: <SiMysql className="text-3xl text-blue-400" />, name: "MySQL", category: "Database" },
  { icon: <SiPostgresql className="text-3xl text-blue-500" />, name: "PostgreSQL", category: "Database" },

  { icon: <FaAws className="text-3xl text-orange-400" />, name: "AWS", category: "Cloud" },
  { icon: <SiDocker className="text-3xl text-blue-400" />, name: "Docker", category: "DevOps" },
  { icon: <SiKubernetes className="text-3xl text-blue-500" />, name: "Kubernetes", category: "DevOps" },
  { icon: <SiRedux className="text-3xl text-purple-400" />, name: "Redux", category: "Frontend" },
  { icon: <SiTailwindcss className="text-3xl text-cyan-400" />, name: "Tailwind CSS", category: "Frontend" },
  { icon: <SiBootstrap className="text-3xl text-purple-500" />, name: "Bootstrap", category: "Frontend" },

  { icon: <SiNestjs className="text-3xl text-red-500" />, name: "NestJS", category: "Backend" },
  { icon: <SiGraphql className="text-3xl text-pink-500" />, name: "GraphQL", category: "Backend" },
  { icon: <SiFirebase className="text-3xl text-yellow-400" />, name: "Firebase", category: "Backend" },

  { icon: <SiRedis className="text-3xl text-red-400" />, name: "Redis", category: "Database" },
  { icon: <SiSqlite className="text-3xl text-blue-300" />, name: "SQLite", category: "Database" },

  { icon: <SiFlutter className="text-3xl text-blue-400" />, name: "Flutter", category: "Mobile" },
  { icon: <SiKotlin className="text-3xl text-purple-400" />, name: "Kotlin", category: "Mobile" },
  { icon: <SiSwift className="text-3xl text-orange-400" />, name: "Swift", category: "Mobile" },

  { icon: <SiVercel className="text-3xl text-white" />, name: "Vercel", category: "Cloud" },
  { icon: <SiNetlify className="text-3xl text-green-400" />, name: "Netlify", category: "Cloud" },

  { icon: <SiGithub className="text-3xl text-gray-300" />, name: "GitHub", category: "Tools" },
  { icon: <SiGitlab className="text-3xl text-orange-400" />, name: "GitLab", category: "Tools" },
  { icon: <SiBitbucket className="text-3xl text-blue-400" />, name: "Bitbucket", category: "Tools" },

  { icon: <SiJenkins className="text-3xl text-red-500" />, name: "Jenkins", category: "DevOps" },
  { icon: <SiNginx className="text-3xl text-green-500" />, name: "Nginx", category: "DevOps" },

  { icon: <SiPostman className="text-3xl text-orange-500" />, name: "Postman", category: "Tools" },
  { icon: <SiWebpack className="text-3xl text-blue-400" />, name: "Webpack", category: "Tools" }
];

const Integrations = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
        }
      });
    }, { threshold: 0.1 });

    const elements = sectionRef.current?.querySelectorAll('.fade-up, .scale-in');
    elements?.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-20 bg-gradient-to-b from-[#0C0E15] to-[#0A0A0F] rounded-t-3xl rounded-b-3xl max-w-7xl mx-auto my-8 px-5 md:px-8">
      <div className="text-center fade-up">
        <h2 className="text-3xl md:text-4xl font-bold">
          Engineering <span className="gradient-text">next-gen digital solutions</span>
        </h2>
        <p className="text-gray-400 mt-3 max-w-2xl mx-auto text-lg">
          Empowering businesses with innovative, scalable, and secure software development services
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mt-12">
        {integrations.map((integration, idx) => (
          <div
            key={idx}
            className="glass-card rounded-xl p-6 text-center transition-all duration-500 hover:scale-110 hover:shadow-2xl cursor-pointer group scale-in"
            style={{ transitionDelay: `${idx * 50}ms` }}
          >
            <div className="flex justify-center mb-3 group-hover:scale-110 transition-transform duration-300">
              {integration.icon}
            </div>
            <p className="font-medium group-hover:text-purple-400 transition">{integration.name}</p>
            <p className="text-xs text-gray-500 mt-1">{integration.category}</p>
          </div>
        ))}
      </div>


    </section>
  );
};

export default Integrations;